import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

const uncertaintyRanges = [
  { min: 55, max: 350, uncertainty: 0.12 },
  { min: 351, max: 1499, uncertainty: 0.11 },
  { min: 1500, max: 3000, uncertainty: 0.3 },
  { min: 3001, max: 5000, uncertainty: 0.39 },
  { min: 5001, max: 10000, uncertainty: 0.8 },
  { min: 10001, max: 15000, uncertainty: 1.8 },
  { min: 15001, max: 40000, uncertainty: 3.4 },
];

function ContactTachometer() {
  const [inputValue, setInputValue] = useState("");
  const [uncertainty, setUncertainty] = useState("");

  const handleChange = (e) => {
    const value = parseFloat(e.target.value);
    setInputValue(e.target.value);

    if (!isNaN(value)) {
      const match = uncertaintyRanges.find(
        (range) => value >= range.min && value <= range.max
      );
      setUncertainty(match ? match.uncertainty.toString() : "Out of range");
    } else {
      setUncertainty("");
    }
  };

  const handleCopy = () => {
    if (uncertainty) {
      navigator.clipboard.writeText(uncertainty);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Enter Value (rpm)"
        variant="outlined"
        type="number"
        value={inputValue}
        onChange={handleChange}
        fullWidth
      />
      <TextField
        label="Uncertainty (rpm)"
        variant="outlined"
        value={uncertainty}
        InputProps={{
          readOnly: true,
        }}
        fullWidth
      />
      <Button
        variant="contained"
        onClick={handleCopy}
        disabled={!uncertainty || uncertainty === "Out of range"}
      >
        Copy
      </Button>
    </Box>
  );
}

export default ContactTachometer;